import { render, staticRenderFns } from "./SchoolsList.vue?vue&type=template&id=b69a8ddc"
import script from "./SchoolsList.vue?vue&type=script&lang=js"
export * from "./SchoolsList.vue?vue&type=script&lang=js"
import style0 from "./SchoolsList.vue?vue&type=style&index=0&id=b69a8ddc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports